module.exports = __webpack_public_path__ + "img/light_12.7dd13769.png";